angular.module('checkout').directive(
    'confirmInfo',
    function () {
        function link($scope) {
            let onPropOrderChange = function () {
                $scope.order = angular.merge({}, $scope.propOrder);
                // if (!$scope.order || !$scope.order.attributes) {
                //     return;
                // }
                //
                // //If using a non-strange ship method, get the name so we can show it
                // $scope.order.attributes.allowedShipMethods.forEach(
                //     function (method) {
                //         if (method.value == $scope.order.shipping.data.shipVia) {
                //             $scope.order.shipViaName = method.label
                //         }
                //     }
                // )
            };

            let init = function () {
                $scope.order = angular.merge({}, $scope.propOrder);
                $scope.$watch(
                    'propOrder',
                    onPropOrderChange
                );
            };

            init();
        }

        return {
            link: link,
            scope: {
                propOrder: '=order', // order object
            },
            template: `
<div class="cartHeader">
    <div class="col-xs-12">
        {{(order.attributes.enrollmentRules.orderIsEnrollment
                        ?'Mailing Address'
                        :'Shipping Address')
                        | translate}}
    </div>
</div>

<div class="addressInfo checkout-confirm-info-body">
    {{order.shipping.data.shipAddress.nameLine}}
    <a class="edit" href="/secure/checkout/v1#/checkout/address" ng-show="order.status == 'active'">
        ({{'edit' | translate}})
    </a>

    <div>
        {{order.shipping.data.shipAddress.addressLine1}}
    </div>
    <div>
        {{order.shipping.data.shipAddress.addressLine2}}
    </div>
    <div>

        {{order.shipping.data.shipAddress.city}}

        {{order.shipping.data.shipAddress.formattedState}}

        {{order.shipping.data.shipAddress.postalCode}}
    </div>
    <div>
        {{order.shipping.data.shipAddress.country}}
    </div>

    <div>
        {{'Phone Number' | translate}}:
        {{order.shipping.data.shipAddress.formattedPhone}}

    </div>
    <div ng-if="order.attributes.currentShipViaLabel">
        {{'Shipping Method' | translate}}:
        {{order.attributes.currentShipViaLabel | translate}}
    </div>
</div>


<div class="cartHeader">
    <div class="col-xs-12">
        {{'Billing Address' | translate}}
    </div>
</div>

<div class="addressInfo checkout-confirm-info-body">
    {{order.billAddress.addressLine1}}
    <a class="edit" href="/secure/checkout/v1#/checkout/address" ng-show="order.status == 'active'">
        ({{'edit' | translate}})
    </a>
    <div>
        {{order.billAddress.addressLine2}}
    </div>
    <div>
        {{order.billAddress.city}}
        {{order.billAddress.formattedState}}
        {{order.billAddress.postalCode}}
    </div>
    <div>
        {{order.billAddress.country}}
    </div>
</div>


<div class="col-xs-12" ng-show="order.attributes.isPvq">
    {{'Pvq Order: Yes' | translate}}
</div>

<div class="col-xs-12" ng-show="order.shipping.data.isAutoShip">
    {{'Auto Ship' | translate}}:
    <span ng-show="order.shipping.data.autoShipIsMonthly">
        {{'Monthly' | translate}}
    </span>
    <span ng-hide="order.shipping.data.autoShipIsMonthly">
        {{'Quarterly' | translate}}
    </span>
</div>
`,
        };
    }
);
